import { ReactNode } from 'react';
import SideMenuFooterLink from '@v2/shared/components/SideMenuFooterLink';
import { FullLayoutProps } from '../Full';
import SideMenuLayout from '../SideMenu';
import { INSTITUTIONAL_MENU } from './menu';

/**
 * The shell the institutional pages share — guarantee, policies, help, reviews.
 *
 * SideMenuLayout with this menu in it. Everything that used to be here — the grid, the
 * collapsing rail, all of it built on Full — moved there when the account pages turned
 * out to want the same shell; what is left is the part that is actually institutional. A
 * page that wants it says `Page.layoutName = 'Layouts.Institutional'` and nothing else,
 * as before, and draws its own breadcrumb.
 *
 * Its props are FullLayoutPropsBuilder's, plus the one thing the server has to decide
 * because a server render has no url to read: which menu entry is the current page.
 */
export type InstitutionalLayoutProps = FullLayoutProps & {
  /** The menu entry to mark, as its path — `/reviews`. */
  activePath?: string;
  children?: ReactNode;
};

export default function Institutional({
  children,
  activePath,
  ...props
}: InstitutionalLayoutProps) {
  return (
    <SideMenuLayout
      label="Customer information"
      ariaLabel="About DiscountMags"
      groups={INSTITUTIONAL_MENU}
      activePath={activePath}
      footer={<SideMenuFooterLink activePath={activePath} />}
      {...props}
    >
      {children}
    </SideMenuLayout>
  );
}
